<template>
  <div id="blue-info-wrapper">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="left-column">
            <div class="h-small">Distrum Agencies</div>
            <div class="h-big">Maecenas sed eros ante pellentesque.</div>
            <div class="p-container">
              <p>
                Nullam dolor velit, gravida vel erat ac, sodales efficitur tortor. Sed facilisis est at facilisis tincidunt. Praesent egestas justo
                ex, vitae dapibus purus fermentum eu.
              </p>
              <p>Nam laoreet, lorem eu blandit maximus, magna dolor posuere elit, sit amet vestibulum velit nulla id ligula.</p>
            </div>
            <div class="logos-container">
              <div class="logo-container">
                <div class="logo">
                  <inline-svg
                    :src="require('@/assets/img/iata.svg')"
                    width="82"
                    height="52"
                    fill="#202A38"
                    aria-label="IATA"
                    class="iata-logo"
                  ></inline-svg>
                </div>

                <span>23286955</span>
              </div>
              <div class="logo-container">
                <div class="logo">
                  <inline-svg
                    :src="require('@/assets/img/drv.svg')"
                    width="78"
                    height="33"
                    fill="#202A38"
                    aria-label="DRV"
                    class="drv-logo"
                  ></inline-svg>
                </div>
                <span>155499</span>
              </div>
              <div class="logo-container">
                <div class="logo">
                  <inline-svg
                    :src="require('@/assets/img/tursab.svg')"
                    width="117"
                    height="45"
                    fill="#202A38"
                    aria-label="TÜRSAB"
                    class="tursab-logo"
                  ></inline-svg>
                </div>
                <span>13182</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col">*</div>
      </div>
    </div>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "BrandCredibility",
  components: {
    InlineSvg,
  },
};
</script>

<style lang="scss" scoped>
#blue-info-wrapper {
  display: flex;
  background: #2268db;
  background: linear-gradient(90deg, #2268db 50%, #fff 50%);
  padding: 5rem 0;
  // height: 100vh;
  align-items: center;

  .left-column {
    padding: 5rem 0;
    padding-right: 10rem;
    color: #fff;

    .h-small {
      font-size: 16px;
      text-transform: uppercase;
      margin-bottom: 1.5rem;
      position: relative;
      display: flex;
      align-items: center;

      &:before {
        content: "*";
        text-indent: -999em;
        height: 1px;
        width: 32px;
        background-color: #fff;
        position: absolute;
        left: -42px;
      }
    }
    .h-big {
      font-size: 52px;
      font-family: "Alice", serif;
    }
    .p-container {
      padding-right: 0.5rem;

      p {
        font-size: 17px;
        font-weight: 300;
        line-height: 1.7rem;
      }
    }
    .logos-container {
      margin-top: 4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }

        span {
          margin-top: 1rem;
        }
      }
    }
  }
}
</style>
